import { useClientExtensionAdoptionRateStatQuery } from "@components/Stats/ClientExtensionAdoptionRateStat/ClientExtensionAdoptionRateStat.g";
import { useParams, Outlet } from "react-router";

import { ExtensionInstructionsCard } from "@components/Cards";

import { Box } from "@design-system/Box/Box";

interface ExtensionInstallationGuardProps {
  children?: React.ReactNode;
}

export const ExtensionInstallationGuard = ({
  children,
}: ExtensionInstallationGuardProps) => {
  const { clientId } = useParams<{ clientId: string }>();

  const { data, isLoading } = useClientExtensionAdoptionRateStatQuery(
    { clientId: clientId! },
    { enabled: !!clientId },
  );

  if (!clientId || isLoading) {
    return null;
  }

  const users = data?.clientEmployees?.edges?.length ?? 0;
  let activeUsers = 0;

  data?.clientEmployees?.edges?.forEach((edge) => {
    if (edge?.node?.sessions?.totalCount && edge.node.sessions.totalCount > 0) {
      activeUsers += 1;
    }
  });

  if (users === 0 && activeUsers === 0) {
    return (
      <Box stretch>
        <ExtensionInstructionsCard clientId={clientId} />
      </Box>
    );
  }

  return children ? <>{children}</> : <Outlet />;
};